require('../../tools/lua.js/lib/polyfill')
require('./util')
require('./xClass')
require('./cocos2d')
require('./hecore')
require('./nightmare')
require("./base64")
if (__DEBUG) {
    require('./debugUtil')
}

// TODO: 
type = function (v) {
    if (v === null || v === undefined) {
        return 'nil'
    }
    var t = typeof (v)
    switch (t) {
        case 'number':
        case 'boolean':
        case 'string':
        case 'function':
            return t
        case 'object':
            if (v.__isLuaTable) {
                return 'table'
            } else {
                // cc.warn(`LuaType: value is not a LuaTable but a JS Object`)
                return v instanceof cc.Class ? 'userdata' : 'table'
            }
        default:
            throw new Error('Unepected value of type ' + t)
    }
}

os.date = function(format, second) {
    var d;
    if (second) {
        d = new Date(second * 1000);
    }else if (second === 0){
        d = new Date(0)
    }else {
        d = new Date()
    }
    var t = {year:d.getFullYear(), month:d.getMonth()+1, day:d.getDate(), hour:d.getHours(),min:d.getMinutes(),sec:d.getSeconds()}
    t.yday = Math.floor(d.getTime() / (86400 * 1000))
    return t
}

// ??
// NegotiatorManager = null
